import { useState } from "react";
import { mediaThumbUrl } from "../lib/api";

// An archer's avatar — their uploaded photo when there is one, otherwise their
// initials. `className` selects the size variant ("ws-avatar" / "ws-avatar sm").
// A photo that fails to load falls back to initials rather than a broken image.
//
// Avatars are list/roster sized (~40px), so they request the small thumbnail
// variant (#1219) rather than the full upload. The profile view renders the
// original directly and does not use this component.
export function Avatar({ archer, className = "ws-avatar" }) {
  const [failed, setFailed] = useState(false);
  const photo = mediaThumbUrl(archer?.photo_url);

  if (photo && !failed) {
    return (
      <div className={className}>
        <img src={photo} alt="" onError={() => setFailed(true)} />
      </div>
    );
  }
  return <div className={className}>{archer?.initials ?? "—"}</div>;
}
